import React from 'react';
import {connect} from 'react-redux';
import {Dispatch} from '@Redux/type';
import {AppState} from '@Redux/store';
import {BookSection} from "@Models";
import {container} from "@Container";
import {TYPES} from "@Types";
import { BookSectionAction } from '@Redux/actions/publication/book-section.action';
import { FormattedMessage } from 'react-intl';
import { defaultMessages } from '@I18n/default';

const SectionCloneComponent: React.FC<Props> = ({section, isLoading, cancel, toClone}) => {

  return (
    <div className="mt-2 text-center">
      <h1><FormattedMessage id={'publication.book.section.clone.form.title'} /></h1>
      {!isLoading &&
        section != null &&
          <div className="action">
              <button className="btn btn-age" type="button" onClick={() => cancel()}><FormattedMessage {...defaultMessages.formCancel} /></button>
              <button className="btn btn-age" type="button" onClick={() => toClone(section)}>
                  <i className="fa fa-clone" aria-hidden="true"/> <FormattedMessage {...defaultMessages.formClone} />
              </button>
          </div>}
    </div>
  );
};

const mapStateToProps = (state: AppState) => ({
  isLoading: state.bookSection.isLoading,
  section: state.bookSection.entity,
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  const action = container.get<BookSectionAction>(TYPES.Actions.Publication.BookSectionAction);
  return {
    toClone: (section: BookSection) => dispatch(action.clone(section)),
    cancel: () => dispatch(action.cancel())
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(SectionCloneComponent);

type Props = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>